import React, { useEffect, useRef, useState } from 'react'
import RoundedInput from "../../components/UI/Cards/Automations/EditAutomations/RoundedInput"

import classes from "./EditScheduledAction.module.css"
import { Button } from 'primereact/button';
import { Tooltip } from 'primereact/tooltip';
import { updateScheduleApi, IgnoreScheduleAPI } from '../../Api Methods/Api';
import { useDispatch } from 'react-redux';
import { UseConvertScheduleTimezone } from '../../components/hooks/UseConvertScheduleTimezone';

const EditScheduledAction = React.forwardRef(({ site, siteDevices, setSiteDevices, body, pins, closeModal, apiData}, ref) => {
    const dispatch = useDispatch();

    const browserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    // schedules created before timezone support have no stored timezone - treat them as already being in the browser's timezone
    const scheduleTimeZone = body?.timezone || browserTimeZone;

    const parsedDays = (() => {
        try {
            return typeof body.days === "string" ? JSON.parse(body.days) : (body.days || []);
        } catch {
            return [];
        }
    })();

    let currentlySetTime;
    let currentlySetTimeArray;
    let currentlySetDays;

    // spilt time into hours and minutes, to populate displayed time. For edit view - converted from the schedule's stored timezone to the viewer's local timezone
    if (body && body.time != "") {
        const converted = UseConvertScheduleTimezone(body.time, parsedDays, scheduleTimeZone, browserTimeZone);
        currentlySetTime = converted.time;
        currentlySetTimeArray = currentlySetTime.split(":");
        currentlySetDays = converted.days;
    }
    const [daysSelected, setdaysSelected] = useState(currentlySetDays || parsedDays || []);
    const [pinsSelected, setPinsSelected] = useState(JSON.parse(body.pins) || []);
    const [isAutoArmed, setIsAutoArmed] = useState(body.action == "Disarm" ? false : true || false);
    const [isAutomationActive, setIsAutomationActive] = useState(body.active || 1);
    const [hour, setHour] = useState(currentlySetTimeArray && currentlySetTimeArray[0] || '12');
    const [minutes, setMinutes] = useState(currentlySetTimeArray && currentlySetTimeArray[1] || "00");

    //edit state
    const [editTime, setEditTime] = useState(false)

    useEffect(() => {
    }, [])


    const HandelOnClick = () => {

        const actionString = HandlePrepareAction();
        const isActive = HandlePrepareIsActive();
        const localTime = HandlePrepareTime();

        if (localTime == "00:00"){
            //error
        }

        // convert the time/days entered in the viewer's local timezone back to the schedule's stored timezone before saving
        const { time, days } = UseConvertScheduleTimezone(localTime, daysSelected, browserTimeZone, scheduleTimeZone);

        const Body = { ...body, days: days, time: time, active: isActive, action: actionString, timezone: scheduleTimeZone }
        UpdateSchedule(Body)
    }

    const UpdateSchedule = async (body) => {
        // the update endpoint doesn't accept a timezone value - a schedule's timezone is fixed at creation and can't be changed via edit
        const { timezone, ...bodyForApi } = body;
        const response = await updateScheduleApi(apiData, bodyForApi, dispatch);
        if (response && response.success) {
            closeModal()

            const updatedParsedSchedules = site.parsedScheduledActions.map((schedule) =>
                schedule.id === body.id ? {
                    id: body.id,
                    days: JSON.stringify(body.days),
                    pins: body.pins,
                    time: body.time,
                    action: body.action,
                    active: body.active,
                    timezone: body.timezone,
                    dateCreated: Date.now()
                } : schedule
            );

            const updatedSite = {
                ...site,
                parsedScheduledActions: updatedParsedSchedules
            };

            setSiteDevices((prevSiteDevices) =>
                prevSiteDevices.map((device) =>
                    device.id === site.id ? updatedSite : device
                )
            );
        }
    }

    const HandlePrepareTime = () => {

        if (hour == "00" && minutes == "00"){
            return "23:59";
        }

        return hour + ":" + minutes;
    }


    const HandlePrepareIsActive = () => {
        return + isAutomationActive; // returns 1 if isAutomationActive is true, and 0 if it's false, regardless of its initial type.
    }

    const HandlePrepareAction = () => {
        return isAutoArmed ? "Arm" : "Disarm";
    }

    const HandleResetAllStates = () => {
        setIsAutoArmed(true)

        setIsAutomationActive(false)
        setEditTime(false)
        setHour(currentlySetTimeArray[0]);
        setMinutes(currentlySetTimeArray[1]);
    }

    // Expose the method to the parent component using ref
    React.useImperativeHandle(ref, () => ({
        HandleResetAllStates: HandleResetAllStates
    }));

    const HandleOnDayClicked = (dayIndex) => {
        const isDayAlreayClicked = daysSelected.find(Day => Day == dayIndex);

        if (isDayAlreayClicked) {
            removeItem(dayIndex)
        } else {
            addItem(dayIndex)
        }
    }

    const addItem = (dayIndex) => {
        // Create a copy of the current array
        const newArray = [...daysSelected];
        // // Push the new item to the copy
        newArray.push(dayIndex);

        // // Set the state with the new array
        setdaysSelected(newArray);

    };

    const removeItem = (dayIndex) => {
        // Create a copy of the current array
        const newArray = [...daysSelected];

        const filterArray = newArray.filter(Day => Day !== dayIndex)

        // Set the state with the new array
        setdaysSelected(filterArray);
    }

    const Days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];


    // ---------------------------- Set Time Logic ------------------------------------------
    useEffect(() => {

        // if the hour input is left blank - repopulate it with previous value
        if (hour == "" || hour == null || hour == undefined) {
            setHour(currentlySetTimeArray[0]);
        }

        // if the Minutes input is left blank - repopulate it with previous value
        if (minutes == "" || minutes == null || minutes == undefined) {
            setMinutes(currentlySetTimeArray[0]);
            setMinutes(currentlySetTimeArray[1]);
        }

        const hourAsString = hour.toString(); // Convert number to string
        const hourAsStringLength = hourAsString.length;

        //if 00:00 set to 23:59


        // make sure hour are not 1 but 01
        if (hourAsStringLength < 2) {
            const newHour = 0 + hour
            setHour(newHour);
        }

        const minutesAsString = minutes.toString(); // Convert number to string
        const minutesAsStringLength = minutesAsString.length;
        // make sure minutes are not 1 but 01
        if (minutesAsStringLength < 2) {
            const newHour = 0 + minutes
            setMinutes(newHour);
        }

        if (hourAsString == "00" && minutesAsString == "00"){
            //invalid
            setHour(23);
            setMinutes(59);
        }
    }, [editTime])

    const handleChangeHour = (event) => {
        if (event.target.value === "") {
            return
        }
        const newValue = event.target.value;
        if (IsHourValueValid(newValue) && IsHourValueValid(newValue)) {
            setHour(newValue)
        }
    };

    const handleChangeMinutes = (event) => {
        if (event.target.value === "") {
            return
        }
        const newValue = event.target.value;
        if (IsValueValid(newValue) && IsMinuteValueValid(newValue)) {
            setMinutes(newValue);
        }
    };

    const IsValueValid = (value) => {
        // check if value is int and the length is not more than 2 characters
        if ((/^\d*$/.test(value) && value.length <= 2)) {
            return true;
        } else {
            return false
        }
    }

    const IsHourValueValid = (value) => {
        // check if value is with 24 hour range
        if (value >= 0 && value <= 23) {
            return true;
        }
    }

    const IsMinuteValueValid = (value) => {
        // check if value is with 24 hour range
        if (value >= 0 && value < 60) {
            return true;
        } else {
            return false
        }
    }

    const getValueLength = (value) => {
        const numberAsString = value.toString(); // Convert number to string
        const numberLength = numberAsString.length;
        if (numberLength < 2) {
            return true
        } else {
            return false;
        }

    }

    const DeleteSchedule = () => {

    }

    // skip this schedule's next run (today) without changing the schedule itself
    const [isIgnoring, setIsIgnoring] = useState(false);
    const [ignoreError, setIgnoreError] = useState("");

    const IgnoreSchedule = async () => {
        setIsIgnoring(true);
        setIgnoreError("");
        const response = await IgnoreScheduleAPI(apiData, body.id, dispatch);
        setIsIgnoring(false);

        if (response && response.success) {
            closeModal();
        } else {
            setIgnoreError("Failed to ignore schedule, please try again.");
        }
    }
    //-------------------------------------------------------------------------------------------

    return (
        <div className={classes.container}>
            <div className={classes.section}>
                <h4>Time</h4>
                {!editTime ?
                    <h2 className={classes.timeDisplay} onClick={() => setEditTime(true)}>{hour + ":" + minutes || "12:00"}</h2> :
                    <div className={classes.timeEditRow}>
                        <RoundedInput value={hour} onChange={handleChangeHour} placeholder={hour || "12"} />
                        :
                        <RoundedInput value={minutes} onChange={handleChangeMinutes} placeholder={minutes || "00"} />
                        <Button icon="pi pi-check" rounded text severity="secondary" aria-label="Done editing time" onClick={() => setEditTime(false)} />
                    </div>
                }
            </div>

            <div className={classes.section}>
                <h4>Repeat</h4>
                <div className={classes.dayRow}>
                    {["0", "1", "2", "3", "4", "5", "6"].map((dayIndex) => {
                        const isSelected = daysSelected.some(Day => Day == dayIndex);
                        return (
                            <Button
                                key={dayIndex}
                                type="button"
                                label={Days[dayIndex]}
                                size="small"
                                severity="secondary"
                                outlined={!isSelected}
                                onClick={() => HandleOnDayClicked(dayIndex)}
                            />
                        );
                    })}
                </div>
            </div>

<br/>
            <div className={classes.btnList}>
                <Button
                    type="button"
                    label="Save changes"
                    icon="pi pi-check"
                    severity="success"
                    disabled={daysSelected.length === 0}
                    onClick={HandelOnClick}
                />
                <div className={classes.btnWithInfo}>
                    <Button
                        type="button"
                        label="Ignore schedule"
                        icon="pi pi-ban"
                        severity="secondary"
                        loading={isIgnoring}
                        onClick={IgnoreSchedule}
                    />
                    {/* className raises the tooltip above the dialog mask, which index.css forces to z-index 9999 */}
                    <Tooltip target=".ignore-schedule-info" position="top" className={classes.infoTooltip} />
                    <i
                        className={`pi pi-info-circle ignore-schedule-info ${classes.infoIcon}`}
                        data-pr-tooltip="This will ignore the next execution of this schedule only. Once that time has passed, the schedule will revert back to running as normal."
                        aria-label="About ignore schedule"
                    />
                </div>
                <Button
                    type="button"
                    label="Remove schedule"
                    icon="pi pi-trash"
                    severity="danger"
                    onClick={DeleteSchedule}
                />
                {ignoreError && <p className={classes.errorText}>{ignoreError}</p>}
            </div>
        </div>
    )
})

export default EditScheduledAction